<template>
  <div class="affix">
    <el-form :model="docItem" status-icon ref="ruleForm" label-width="180px" class="demo-ruleForm" v-loading="loadingFlag">
      <div class="title_name clearfix" v-if="showFileName">
        <p >
          <!--          <em class="el-icon-paperclip"></em>-->
          <em class="el-icon-view" @click="fileView()"></em>
          <span @click="fileView()" class="doc_name">{{docName}}</span>
          <span class="deleteIcon" v-if="!showDetail">
            <em class="el-icon-close" @click="delMent(docItem)"></em>
          </span>
        </p>
      </div>
      <p class="doc-btn" v-if="!docItem.hideLable">
        <input :accept="accpt" :multiple="multiple"  :ref="attachmentId" @change="uploadName" name="attachmentId" style="display: none" type="file">
        <label class="upload" @click="uploadBtn($event)">
          <em class="el-icon-upload2"></em>
          <span>上传</span>
        </label>
        <span style="margin-left: 10px;color: rgba(0, 0, 0, 0.45);font-weight: normal;font-size: 14px;">
          <em class="el-icon-warning-outline"></em>允许上传文件：{{this.accpt}}
        </span>
        <b v-if="downBtn && docItem.describeInfo" style="color: rgba(0, 0, 0, 0.45);font-weight: normal;font-size: 14px;">
          <i class="el-icon-warning-outline" style="margin: 0 5px 0 8px"></i>{{docItem.describeInfo}}</b>
      </p>
    </el-form>
    <!--    <loadingTel v-if="loadingFlag" :textType="2" />-->
    <el-dialog :visible.sync="imgDialogVisible" width="740px" height="100%" @closed="dialogClose" top="10vh">
      <img :src="docItem.filePath" alt="" @contextmenu.prevent=""  class="viewImg">
    </el-dialog>
    <el-dialog :visible.sync="pdfDialogVisible" width="100%" height="100%" @closed="dialogClose" >
      <iframe  :src="pdfViewer + pdfFileSrc + '?range=true' " @contextmenu.prevent="" frameborder="0" height="500" width="100%"></iframe>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loadingFlag:false,
        pdfDialogVisible:false,
        imgDialogVisible:false,
        pdfViewer:'/pdf/web/viewer.html?file=',
        attachmentId: 'attachment' + new Date().getTime(),
        showUpload: true,
        pdfFileSrc:"",
        baseUrl:"",
        accpt:'',
      }
    },
    props: {
      showDetail:{
        type: Boolean,
        default:false,
      },
      docName:{
        type: String,
        default:'',
      },
      multiple:{
        type: Boolean,
        default:false,
      },

      uploadUrl:{
        type: String,
        default:'/attachment/uploadFile',
      },
      docItem: {
        type: Object,
        required: true
      },
      type: {
        type: String,
        default:'check_result_att',
      },
      downBtn:{
        type: Boolean,
        default:false,
      },
    },
    watch:{
      docItem(val){
        this.$emit('update:docItem',val)
      },
    },
    computed:{
      showFileName: {
        get () {
          return this.docName != '' 
          }
      },
    },
    created() {
      this.pdfViewer = process.env.VUE_APP_proxybaseurl + this.pdfViewer;
      // this.getFileServeBaseUrl();
    },
    mounted(){

      this.accpt = this.docItem.allows?this.docItem.allows:".pdf,.PDF,.doc,.DOC,.docx,.DOCX,.xls,.XLS,.xlsx,.XLSX,.png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.bmp,.BMP";

      if(this.docItem.filePath){
        // this.fileList.push(this.docItem.filePath);
        // this.$emit('update:fileLists', this.fileList);
      }
    },
    methods: {

      getFileServeBaseUrl(){

        if( sessionStorage.getItem('fileServerBaseUrl') ){
          this.baseUrl = sessionStorage.getItem('fileServerBaseUrl')
        }else{
          // 查询 baseUrl 地址
          this.$httpReq.get('/viewFileUrl').then(res => {
            if (res.data.code === '1') {
              this.baseUrl = res.data.data;
              sessionStorage.setItem('fileServerBaseUrl',this.baseUrl)
            }
          })

        }
      },
      fileView(){

        // 获取文件类型
        let type = this.docName.substr(this.docName.lastIndexOf(".")+1);
        let imgFlag = this.isAssetTypeAnImage(type);
        let pdfFlag = this.isAssetTypeAnPDF(type);
        if(pdfFlag){
          this.imgDialogVisible = false;
          // this.pdfDialogVisible = true;
          this.pdfFileSrc = this.docItem.filePath;
          const pdfFilePath = this.pdfViewer + this.docItem.filePath + '?range=true';
          window.open(pdfFilePath);
          return
        }
        if(imgFlag){
          this.imgDialogVisible = true;
          this.pdfDialogVisible = false;
        }else{
          this.docXia();
        }

      },

      docXia(){
        this.$httpReq({
          method:'get',
          url:`/sys/upload/downfile?filePath=${encodeURI(this.docItem.filePath)}`,
          responseType:'blob'
        }).then(res => {
          // let blob = new Blob([res.data],{type:'application/pdf'})
          // this.url = window.URL.createObjectURL(blob);
          let blob = new Blob([res.data])
          let fileName = this.docItem.name
          if('msSaveOrOpenBlob' in navigator){
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          }else {
            let link = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = link;
            a.style.display = 'none';
            a.setAttribute('download', fileName);
            document.body.appendChild(a);
            a.click();
            // 移除元素
            document.body.removeChild(a);
            window.URL.revokeObjectURL(link);
            // this.url = window.URL.createObjectURL(blob);
          }
        })
      },

      dialogClose() {
        this.dialogImageUrl = "";
        this.imgDialogVisible = false;
      },
      isAssetTypeAnImage(ext){
        let arr = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg','tif','tiff'];
        return arr.indexOf(ext.toLowerCase()) !== -1;
      },
      isAssetTypeAnPDF(ext) {
        let arr = ['pdf', 'PDF']
        return arr.indexOf(ext.toLowerCase()) !== -1;
      },

      uploadName() {
        var that = this;
        let AllupExt = this.getAccpet();

        for(var i = 0;i<this.$refs[that.attachmentId].files.length;i++){

          var fileIndex = i;
          if(!this.multiple && fileIndex > 0){  // 单个文件上传时，用户选择多文件，只处理下标为0的 文件，其他的不予处理
            return
          }

           let fileObj = this.$refs[that.attachmentId].files[fileIndex];
           let extName = fileObj.name.substring(fileObj.name.lastIndexOf('.')).toLowerCase();
            if (AllupExt.indexOf(extName) == '-1') {
              this.$alert(fileObj.name + '文件格式不正确，请重新上传', '警告', {
                confirmButtonText: '确定',
              })
              break;
            }

          this.showUpload = false;
          let fd = new FormData();
          fd.append('xlsFile', fileObj);
          fd.append('table', this.type);
          this.loadingFlag = true;
          this.$httpReq.post(this.uploadUrl, fd).then(res => {
            if(res.data.code!='1'){
              this.loadingFlag = false;
              this.$alert('文件上传失败！', '警告', {
                confirmButtonText: '确定',
              });
              return;
            }
            if(fileIndex == 0 && !this.docItem.name){
              this.$emit('update:docName', res.data.data.name || '')
              this.docItem.filePath = res.data.data.filepath;
              this.docItem.name = res.data.data.name;
              // this.$refs[this.attachmentId].value = '';
              // this.fileList.push(res.data.data.filepath);
              this.$emit('update:docItem', this.docItem);
              this.$emit('uploadSuccess',this.docItem.fileType)
              // this.$emit('update:fileLists', this.fileList);
              this.loadingFlag = false;
              this.$message({
                title: '文件上传',
                message: res.data.msg,
                position: 'bottom-right',
                type: 'success'
              })
            }else{
              let docItemTemp = JSON.parse(JSON.stringify(this.docItem))
              docItemTemp.name = res.data.data.name || '';
              docItemTemp.hideLable = true;
              docItemTemp.filePath = res.data.data.filepath;
              this.$emit('multipleUploadSuccess',docItemTemp)
            }

          })


        }


      },
      delMent(docItem) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          if (this.docItem.id){
            this.$httpReq({
              method:'post',
              url:`/attachment/delattachmentbyid`,
              params: {
                id:this.docItem.id
              }
            }).then(res => {
              if (res.data.code == 1){
                this.deleteMes(docItem)
              }
            })
          }else {

            this.deleteMes(docItem)
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      deleteMes(docItem){
        this.$emit('update:docName','')
        this.docItem.name= '';
        this.docItem.id='';
        this.docItem.filePath='';
        this.showUpload = true;
        this.$emit('update:docItem', this.docItem);
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      },
      uploadBtn(e) {
        this.$refs[this.attachmentId].click()
      },
      getAccpet(){
        var str= this.accpt
        let reg=new RegExp(',','g')
        return str.replace(reg,"|");
      },

    },

  }
</script>

<style lang="scss" scoped>
  em{

  }

  .title_name{
    width: 100%;
  }
  .title_name p{
    width: 100%;
    height: 30px;
    line-height: 28px;
    position: relative;
    cursor: pointer;
    border-bottom: 1px solid #dcdfe6;
    margin-top: 0px 0px 10px 0px;
  }

  .title_name p .doc_name{
    margin-left: 6px;
    display: inline-block;
    border-bottom: 1px solid #1890FF;
    position: relative;bottom: -1px
  }

  .title_name p .deleteIcon{
    position: absolute;
    /* right:0; */
    margin-left: 40px;
  }

  .color_inner{
    margin-right: 10px;
    color: red;
  }
  .download{
    margin: 0 0 0 10px;
  }
  .fileAdd{
    margin: 0 10px;
  }
  /deep/ .el-dialog__body{
    text-align: center;
  }
  /deep/ .el-dialog__body img{
    width: 700px;
  }
</style>
